var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaxi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Taxi-Sign--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Taxi Sign Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5v1a0.25 0.25 0 0 0 0.5 0v-1c0 -0.28 -0.5 -0.28 -0.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44 16.77a0.24 0.24 0 0 1 -0.19 -0.24v-8a2.75 2.75 0 0 0 -2.75 -2.78h-17A2.75 2.75 0 0 0 0.75 8.5v8a0.24 0.24 0 0 1 -0.19 0.24 0.75 0.75 0 0 0 0.19 1.48h22.5a0.75 0.75 0 0 0 0.19 -1.48ZM7 10.25a0.25 0.25 0 0 0 -0.25 0.25v4a0.75 0.75 0 0 1 -1.5 0v-4a0.25 0.25 0 0 0 -0.25 -0.25 0.75 0.75 0 0 1 0 -1.5h2a0.75 0.75 0 0 1 0 1.5Zm5 4.25a0.75 0.75 0 0 1 -1.5 0v-1a0.25 0.25 0 0 0 -0.5 0v1a0.75 0.75 0 0 1 -1.5 0v-4a1.75 1.75 0 0 1 3.5 0Zm3.34 -2.41 0.86 2.13a0.76 0.76 0 0 1 -0.42 1 0.92 0.92 0 0 1 -0.28 0.05 0.76 0.76 0 0 1 -0.7 -0.47l-0.07 -0.18a0.25 0.25 0 0 0 -0.46 0l-0.07 0.18a0.76 0.76 0 0 1 -0.7 0.47 0.92 0.92 0 0 1 -0.28 -0.05 0.76 0.76 0 0 1 -0.42 -1l0.86 -2.13a0.28 0.28 0 0 0 0 -0.18l-0.86 -2.13a0.75 0.75 0 0 1 1.4 -0.56l0.07 0.18a0.25 0.25 0 0 0 0.46 0l0.07 -0.18a0.75 0.75 0 0 1 1.4 0.56l-0.86 2.13a0.28 0.28 0 0 0 0 0.18Zm3.16 2.41a0.75 0.75 0 0 1 -1.5 0v-5a0.75 0.75 0 0 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaxi);
export default ForwardRef;